import getFixedPlanBenefits from 'utils/pivot/plan/getFixedPlanBenefits'
import makeBase from 'core/services/email/sendEmailFromAgent/makeBase'
import store from 'utils/store/withMiddleware'
import { DETAILS } from 'sites/routes'
import getLatitudeBenefits from 'core/controllerPlans/renderDetails/getLatitudeBenefits'
import getBadgeDental from 'core/controllerPlans/getBadgeDental'
import detailsDentalFees from 'core/controllerPlans/detailsDentalFees'
import { numberToCurrency } from '@hc-frontend/utils'
import getURLProfile from 'utils/pivot/member/getURLProfile'

const TEMPLATE_NAME = 'fixed-indemnity-slaico-lmb-january-2022'
const asMoneyWithoutDecimal = numberToCurrency

function makePayload({
  valuesForm,
  agentInformation,
  salesCenterAgent,
  latitudeJson,
  propertyPlanId
}) {
  const state = store.getState()
  const planId = state[propertyPlanId]
  const plan = state.plans[planId]

  const { latitudeAddons, dentalAddons, visionAddons } = store.getState()

  const latitudeId = state.latitudeId || latitudeAddons[planId]
  const dentalId = state.dentalPlanId || dentalAddons[planId]
  const visionId = state.visionPlanId || visionAddons[planId]

  const data = makeBase({ valuesForm, agentInformation, salesCenterAgent })
  const urlProfile =
    getURLProfile({
      salesCenterAgent,
      agentId: agentInformation.agent_id,
      planId
    }) + `&uid=${state.hcStorage.healthcareUserId}`

  data.template_name = TEMPLATE_NAME
  data.message.global_merge_vars = data.message.global_merge_vars.concat([
    {
      name: 'plan',
      content: {
        link: `https://${window.location.hostname}${DETAILS}?${urlProfile}`,
        title: plan.planName,
        brochure: state.brochures[plan.brochureId],
        details: getFixedPlanBenefits(plan).map(e => ({
          key: e.title || undefined,
          value: e.value || undefined,
          helper: e.label || undefined
        }))
      }
    },
    {
      name: 'prices',
      content: {
        plan: state.prices.plan,
        dental: state.prices.dentalVision,
        latitude: state.prices.latitude,
        total: state.prices.total,
        fee: state.prices.subscriptionFee
      }
    }
  ])

  if (dentalId) {
    const dentalPlan = state.plans[dentalId]

    const dentalVisionTitle = state.dentalVisionTitle || plan.dentalVisionTitle

    const badgeData = getBadgeDental(
      state.addOnTitle || dentalPlan.planName,
      state.hcStorage.members
    )

    data.message.global_merge_vars.push({
      name: 'dental',
      content: {
        name: dentalVisionTitle,
        fees: detailsDentalFees(dentalPlan, state.plans[visionId]),
        brochure: state.brochures[dentalPlan.brochureId],
        badge: badgeData.message,
        details: [
          `<span>Preventive<br />& Diagnostic <b>${dentalPlan.coreBenefits.preventiveDiagnostic}</b></span>`,
          `<span>Basic Services<br /><b>${dentalPlan.coreBenefits.basicServices}</span>`,
          `<span>Major Services<br /><b>${dentalPlan.coreBenefits.majorServices}</b></span>`,
          `<span>Deductible<br /><b>${dentalPlan.coreBenefits.deductible}</b></span>`
        ]
      }
    })
  }

  if (latitudeId) {
    const response = getLatitudeBenefits(latitudeJson.membershipBenefits)
    const latitudePlan = state.plans[latitudeId]

    data.message.global_merge_vars.push({
      name: 'latitude',
      content: {
        name: latitudePlan.planName,
        brochure: state.brochures[latitudePlan.brochureId],
        message: response.membersBenefits,
        disclaimer: response.disclaimer,
        details: [
          `<span>Accident<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.accidentalDeath
          )}</b></span>`,
          `<span>Critical illness<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.criticalIllness
          )}</b></span>`,
          `<span>Accidental death<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.accidentalDeath
          )}</b></span>`,
          `<span>Hospital benefits<br /><b>${asMoneyWithoutDecimal(
            +latitudePlan.coreBenefits.hospitalBenefits
          )}/day</b></span>`
        ]
      }
    })
  }

  return data
}

export default makePayload
